<div class="chart-section">
  <div class="label" title="{{chartData?.category}}">
      {{chartData?.category}}
  </div>
  <div class="graph"></div>
</div>
